import * as React from 'react';
import * as styles from '../styles.css';

import { Grid, Row, ArticleHeading1, Col } from '@cian/ui-kit';

import { IHeaderLayoutProps } from '../types';

export const MobileView: React.FC<IHeaderLayoutProps> = ({ headerText, subheaderText, agentCard, features }) => {
  return (
    <div data-testid="HeroResult_mobile" className={styles['layout']}>
      <div className={styles['content']}>
        <Grid>
          <Row>
            <Col xs={12}>
              <ArticleHeading1 color="text-inverted-default" as="h1">
                {headerText}
              </ArticleHeading1>
              <div className={styles['subheader']}>{subheaderText}</div>
              <div className={styles['features']}>
                {features.reverse().map((feature, i) => (
                  <div className={styles['feature']} key={i}>
                    {feature}
                  </div>
                ))}
              </div>
              {agentCard}
            </Col>
          </Row>
        </Grid>
      </div>
    </div>
  );
};

MobileView.displayName = 'MobileView';
